<template>
    <v-card flat>
      <v-card-text class="pa-2">
        <v-row>
          <v-col cols="12" md="6">
            <v-checkbox v-model="isPersonal" :label="$t('contacts.columns.isPersonal')"></v-checkbox>
          </v-col>
          <v-col cols="12" md="6">
            <v-checkbox v-model="useAsCallerid" :label="$t('contacts.columns.useAsCallerid')"></v-checkbox>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" md="6">
            <v-avatar size="64">
              <v-img v-if="contact && contact.hasImage" :src="contact.imageUrl" :alt="contact ? contact.name : ''"></v-img>
              <v-img v-else src="/default_picture_profile.png" :alt="contact ? contact.name : ''"></v-img>
            </v-avatar>
          </v-col>
          <v-col cols="12" md="6">
            <v-file-input
              :label="$t('contacts.columns.image')"
              accept="image/png, image/jpeg, image/bmp"
              prepend-icon="mdi-camera"
              v-model="image"
            >
            </v-file-input>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" md="6">
            <v-text-field
              v-model="lastName"
              :rules="nameRules"
              :label="$t('contacts.columns.lastName')"
              required
            ></v-text-field>
          </v-col>
          <v-col cols="12" md="6">
            <v-text-field
              v-model="firstName"
              :rules="nameRules"
              :label="$t('contacts.columns.firstName')"
              required
            ></v-text-field>
          </v-col>
        </v-row>
        <fieldset class="rounded-lg pa-2">
          <legend>{{ $t('contacts.columns.phoneNumbers') }}</legend>
          <ContactFormPhoneNumbers/>
        </fieldset>
        <fieldset class="rounded-lg pa-2">
          <legend>{{ $t('contacts.columns.emails') }}</legend>
          <ContactFormEmails/>
        </fieldset>
        <v-row class="mt-3">
          <v-combobox
            v-model="personalTagsAsArray"
            :items="allPersonalTagsAsArray"
            chips
            clearable
            v-if="isPersonal"
            :label="$t('contacts.columns.personalTags')"
            multiple
            solo
          >
            <template v-slot:selection="{ attrs, item, select, selected }">
              <v-chip
                v-bind="attrs"
                :input-value="selected"
                close
                @click="select"
                @click:close="removePersonalTag(item)"
              >
                <span>{{ item }}</span>
              </v-chip>
            </template>
          </v-combobox>
          <v-combobox
            v-model="tagsAsArray"
            :items="allTagsAsArray"
            chips
            clearable
            v-else
            :label="$t('contacts.columns.tags')"
            multiple
            solo
          >
            <template v-slot:selection="{ attrs, item, select, selected }">
              <v-chip
                v-bind="attrs"
                :input-value="selected"
                close
                @click="select"
                @click:close="removeTag(item)"
              >
                <span>{{ item }}</span>
              </v-chip>
            </template>
          </v-combobox>
        </v-row>
      </v-card-text>
    </v-card>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import ContactFormPhoneNumbers from '@/components/contacts/forms/contact/phone_numbers'
import ContactFormEmails from '@/components/contacts/forms/contact/emails'
export default {
  name: 'contacts-form-fields-mainTab',
  components: { ContactFormPhoneNumbers, ContactFormEmails },
  data () {
    return {
      labels: null,
      nameRules: [
        v => !!v || this.$t('contacts.formValidation.required'),
        v => (v && v?.length >= 2) || this.$t('contacts.formValidation.minimumChar', { min: 2 })
      ]
    }
  },
  computed: {
    ...mapGetters({
      isUpdate: 'contacts/form/isUpdate',
      formIsPersonal: 'contacts/form/isPersonal',
      contact: 'contacts/form/contact',
      tags: 'contacts/tags/tags',
      personalTags: 'contacts/personalTags/personalTags'
    }),
    allTagsAsArray () {
      const data = []
      if (this.tags) {
        this.tags.forEach(tag => {
          data.push(tag.name)
        })
      }
      return data
    },
    allPersonalTagsAsArray () {
      const data = []
      if (this.personalTags) {
        this.personalTags.forEach(tag => {
          data.push(tag.name)
        })
      }
      return data
    },
    isPersonal: { get () { return this.contact?.isPersonal }, set (isPersonal) { this.setIsPersonal(isPersonal) } },
    useAsCallerid: { get () { return this.contact?.useAsCallerid }, set (useAsCallerid) { this.setUseAsCallerid(useAsCallerid) } },
    lastName: { get () { return this.contact?.lastName }, set (lastName) { this.setLastName(lastName) } },
    firstName: { get () { return this.contact?.firstName }, set (firstName) { this.setFirstName(firstName) } },
    tagsAsArray: { get () { return this.contact?.tagsAsArray }, set (tagsAsArray) { this.setTagsAsArray(tagsAsArray) } },
    personalTagsAsArray: { get () { return this.contact?.personalTagsAsArray }, set (personalTagsAsArray) { this.setPersonalTagsAsArray(personalTagsAsArray) } },
    image: { get () { return this.contact?.image }, set (image) { this.setImage(image) } }
  },
  methods: {
    ...mapActions({
      setIsPersonal: 'contacts/form/setIsPersonal',
      setUseAsCallerid: 'contacts/form/setUseAsCallerid',
      setLastName: 'contacts/form/setLastName',
      setFirstName: 'contacts/form/setFirstName',
      setTagsAsArray: 'contacts/form/setTagsAsArray',
      setPersonalTagsAsArray: 'contacts/form/setPersonalTagsAsArray',
      setImage: 'contacts/form/setImage'
    }),
    removeTag (item) {
      this.tagsAsArray = [...this.tagsAsArray.toSpliced(this.tagsAsArray.indexOf(item), 1)]
    },
    removePersonalTag (item) {
      this.personalTagsAsArray.splice(this.personalTagsAsArray.indexOf(item), 1)
      this.personalTagsAsArray = [...this.personalTagsAsArray]
    }
  }
}
</script>

<style>
</style>
